import React, { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import axios from "axios";
import { useToast } from "../hooks/use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Pledge = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "", website: "" });
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: "Vyplňte meno a e-mail", variant: "destructive" });
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast({
        title: "Ďakujeme za podporu!",
        description: `${form.name}, vašu správu sme odoslali.`,
      });
      setForm({ name: "", email: "", message: "", website: "" });
    } catch (err) {
      toast({
        title: "Správu sa nepodarilo odoslať",
        description: "Skúste to prosím o chvíľu znova.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-campaign-cream border-2 border-campaign-ink px-4 py-3 font-semibold text-campaign-ink placeholder:text-campaign-ink/40 focus:outline-none focus:ring-4 focus:ring-campaign-yellow";

  return (
    <section id="podpora" className="bg-campaign-ink py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-display text-4xl sm:text-6xl text-campaign-yellow leading-none">
            Pridajte sa
          </h2>
          <p className="mt-4 text-campaign-cream/80 text-base sm:text-lg">
            Zanechajte nám odkaz a staňte sa súčasťou zmeny v Ružomberku.
          </p>
        </div>

        <form
          onSubmit={submit}
          className="bg-campaign-blue border-4 border-campaign-cream p-6 sm:p-8 space-y-5"
        >
          {/* Honeypot - skryté pole proti botom (nevypĺňať) */}
          <input
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            value={form.website}
            onChange={(e) => setForm({ ...form, website: e.target.value })}
            style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", opacity: 0 }}
          />
          <div>
            <label className="block font-bold uppercase text-sm text-campaign-cream mb-2">Meno a priezvisko *</label>
            <input
              className={field}
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Vaše meno"
            />
          </div>
          <div>
            <label className="block font-bold uppercase text-sm text-campaign-cream mb-2">E-mail *</label>
            <input
              type="email"
              className={field}
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="vas@email.sk"
            />
          </div>
          <div>
            <label className="block font-bold uppercase text-sm text-campaign-cream mb-2">Odkaz</label>
            <textarea
              rows={4}
              className={field}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Napíšte nám..."
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-campaign-yellow text-campaign-ink font-display uppercase text-lg px-6 py-4 border-2 border-campaign-ink shadow-brutal-yellow hover-lift disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                Odosielam <Loader2 size={20} className="animate-spin" />
              </>
            ) : (
              <>
                Odoslať <Send size={20} />
              </>
            )}
          </button>
          <p className="text-campaign-cream/60 text-xs text-center">
            Vaše údaje používame v súlade s ochranou osobných údajov.
          </p>
        </form>
      </div>
    </section>
  );
};

export default Pledge;
